import templateUrl from "emun.invoice/inv/inv-line-attributes.htm";
import directive from "emun.invoice/inv/inv-line.directive";

export default directive(templateUrl);
